export default __webpack_public_path__ + "static/media/banner-image.3e084c68.png";